import { useQuery } from "@tanstack/react-query";
import { listPortalEvents } from "services/portalEvents.service";
import { rowFromPortalList } from "pages/Events/commons/events.helpers";

const PAGE_SIZE = 50;
const MAX_PAGES = 20;

/**
 * Loads the vendor's events (past included) from the existing portal event
 * list for the code form's picker (contract §5.3, D-3). Wizard drafts that
 * were never finished (IN_PROGRESS) are left out.
 */
async function loadVendorEvents() {
  const rows = [];
  for (let page = 1; page <= MAX_PAGES; page += 1) {
    const { data: envelope, errors } = await listPortalEvents({
      current_page: page,
      page_size: PAGE_SIZE,
    });
    if (errors?.length) throw errors;
    const pageRows = Array.isArray(envelope?.data) ? envelope.data : [];
    rows.push(...pageRows);
    const total = envelope?.meta?.pagination?.total;
    if (pageRows.length < PAGE_SIZE) break;
    if (typeof total === "number" && rows.length >= total) break;
  }
  return rows
    .map(rowFromPortalList)
    .filter((e) => e.id && e.status !== "IN_PROGRESS");
}

export default function useVendorEvents({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: ["discount-codes-vendor-events"],
    queryFn: loadVendorEvents,
    enabled,
    staleTime: 60 * 1000,
    retry: false,
  });
  return {
    events: query.data ?? [],
    loading: query.isLoading && enabled,
    errors: query.isError ? query.error : null,
  };
}
